import React, { useEffect, useState } from "react";

type VideoRejectModalProps = {
  isOpen: boolean;
  title?: string;
  onClose: () => void;
  onSubmit: (reason: string) => void;
  isSubmitting?: boolean;
};

const VideoRejectModal = ({
  isOpen,
  title = "Reject video",
  onClose,
  onSubmit,
  isSubmitting = false,
}: VideoRejectModalProps) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setReason("");
      setError("");
    }
  }, [isOpen]);

  const handleSubmit = () => {
    if (!reason.trim()) {
      setError("Rejection reason is required");
      return;
    }
    onSubmit(reason.trim());
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full max-w-lg mx-4 p-6 rounded-lg shadow-lg">
        <h2 className="text-xl font-semibold text-gray-800 mb-4 text-left">
          {title}
        </h2>
        <label
          htmlFor="video-rejection-reason"
          className="block text-left text-gray-700 mb-2"
        >
          Rejection reason
        </label>
        <textarea
          id="video-rejection-reason"
          name="reason"
          rows={4}
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            if (error) setError("");
          }}
          placeholder="Explain why this video is being rejected"
          className={`w-full px-4 py-2 border ${
            error ? "border-red-500" : "border-gray-300"
          } rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500 resize-none`}
        />
        {error ? (
          <span className="text-red-500 text-sm text-left block mt-1">
            {error}
          </span>
        ) : null}

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={isSubmitting}
            className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="px-4 py-2 text-white bg-red-600 rounded-md hover:bg-red-700 transition disabled:opacity-50"
          >
            {isSubmitting ? "Rejecting..." : "Reject video"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoRejectModal;
